/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Checkbox, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { isEmpty } from 'underscore';
import moment from 'moment';
import DOM from './assets';
import AssetsTab from './tabs/AssetsTab';
import DivisionTab from './tabs/DivisionTab';
import * as AssetActions from '../../core/asset/assetActions';
import * as DivisionActions from '../../core/division/divisionActions';
import * as FiltersActions from '../../core/filters/filtersActions';
import * as DeviceActions from '../../core/device/deviceActions';
import AddressFetcher from '../../components/elements/AddressFetcher';
import * as tagActions from '../../core/companyTag/companyTagActions';

class Assets extends Component {
    constructor(match, props) {
        super(match, props);

        let currentTabKey = '1';

        if (match && match.match && match.match.url) {
            if (match.match.url === '/divisions') {
                currentTabKey = '2';
            }
        }
        this.state = {
            divisionSearchParams: {},
            divisionOrderParams: {},
            currentTabKey: currentTabKey || '1',
            data: [],
            showAddDivisionModal: false,
            newDivisionName: '',
            showTagsModal: false,
            selectedTagsToAssign: null,
            tagsAssignErrorMessage: '',
        };
        this.view = DOM;
        this.assetTabContent = AssetsTab;
        this.divisionTabContent = DivisionTab;
    }

    componentDidMount() {
        const {
            actions, assetTabFilters, tagsTabFilters, orderParams, asset,
        } = this.props;

        actions.resetAssetIsFetchings();
        actions.filterAssetsRequest({ 
            page: asset.pagination.currentPage, 
            searchParams: assetTabFilters,  
            orderParams 
        });
        actions.getDivisionsGridRequest();
        actions.getDivisionsRequest();
        actions.getVehicleTypesRequest();
        actions.getCompanyTagsRequest();
        actions.filterCompanyTagsRequest({
            page: 1, 
            searchParams: tagsTabFilters 
        });
    }

    componentDidUpdate(prevProps) {
        const { asset } = this.props;

        if (asset !== prevProps.asset) {
            this.formatData();
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;

        actions.saveAssetSearchParamsRequest({});
    }

    handleTabChange = (tabKey) => {
        this.setState({ currentTabKey: tabKey });
    };

    formatData() {
        const { asset, user, actions, selectedAssets } = this.props;

        const formattedData = [];
        const NOT_SET_STRING = '-';
        if (!isEmpty(asset.assets)) {
            asset.assets.map((item) => {
                const tempItem = {
                    id: item.id,
                    asset: item.name ? item.name : NOT_SET_STRING,
                    registration: item.registration ? item.registration : NOT_SET_STRING,
                    category: item.category ? item.category : NOT_SET_STRING,
                    division: (<div>{item.division ? item.division : NOT_SET_STRING}</div>),
                    type: (<div>{item.vehicle_type ? item.vehicle_type : NOT_SET_STRING}</div>),
                    make: (<div>{item.make ? item.make : NOT_SET_STRING}</div>),
                    fuel_type: (<div>{item.fuel_type}</div>),
                    last_moved: item.last_moved ? moment(item.last_moved).format('D/M/YY HH:mm') : NOT_SET_STRING,
                    last_updated: item.last_updated ? moment(item.last_updated).format('D/M/YY HH:mm') : NOT_SET_STRING,
                    last_location: (
                        <AddressFetcher
                            key={item.id}
                            lat={item.lat}
                            lng={item.lng}
                        />
                    ),
                    last_driver: item.full_name ? (
                        <div onClick={(e) => { e.stopPropagation(); }}>
                            <Link to={`/drivers/view/${item.user_id}`}>{item.full_name}</Link>
                        </div>
                    ) : NOT_SET_STRING,
                    actions: (
                        <>
                            <Link
                                to={`/assets/view/${item.id}`}
                                className="btn-actions"
                            >
                                View
                            </Link>
                            {user.permissions.editing_assets && (
                                <Tooltip title="Select Asset">
                                    <Checkbox
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            actions.toggleAssetSelected(item.id);
                                        }}
                                        checked={selectedAssets.includes(item.id)}
                                        className='btn-actions'
                                    />
                                </Tooltip>
                            )}
                        </>
                    ),
                };
                formattedData.push(tempItem);
            });
            this.setState({ data: formattedData });
        } else {
            this.setState({ data: [] });
        }
    }

    filterAssets(newFilters) {
        const { actions, orderParams } = this.props;
        actions.saveAssetSearchParamsRequest(newFilters);
        actions.filterAssetsRequest({ page: 1, searchParams: newFilters, orderParams });
        actions.setAssetTabFilters(newFilters);
    }

    handleExport = () => {
        const { actions, assetTabFilters } = this.props;
        actions.filterAssetsExportRequest({searchParams: assetTabFilters});
    };

    filterDivisions(newFilters) {
        const { actions, divisionOrderParams } = this.props;

        actions.getDivisionsGridRequest({ page: 1, searchParams: newFilters, divisionOrderParams });
        actions.setDivisionTabFilters(newFilters);
    }

    filterTags(newFilters) {
        const { actions } = this.props;

        actions.filterCompanyTagsRequest({ page: 1, searchParams: newFilters });
        actions.setTagsTabFilters(newFilters);
    }

    paginationChange(page) {
        const { actions, asset, assetTabFilters, orderParams } = this.props;

        if (page !== asset.pagination.currentPage) {
            actions.filterAssetsRequest({ page, searchParams: assetTabFilters, ...orderParams });
        }
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { actions, asset, assetTabFilters } = this.props;

        // checking when only order changes
        if (pagination && pagination.current == asset.pagination.currentPage) {
            const params = { orderBy: `${sorter.order === 'descend' ? '-' : ''}${sorter.field}` };
            // orderParams[sorter.field] = sorter.order ? sorter.order : false;
            this.setState({ orderParams: params });
            actions.saveAssetOrderParamsRequest(params);
            actions.filterAssetsRequest({ page: asset.pagination.currentPage, searchParams: assetTabFilters, ...params });
        }
    };

    render() {
        return this.view();
    }
}

Assets.propTypes = {
    actions: PropTypes.object.isRequired,
    asset: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    assetTabFilters: PropTypes.object.isRequired,
    isExportingCsv: PropTypes.bool.isRequired,
    orderParams: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        asset: state.asset,
        isFetchingDivision: state.division.isFetching,
        divisions: state.division.divisions,
        divisionsPagination: state.division.divisionsPagination,
        assetTabFilters: state.filters.assetTabFilters,
        tagsTabFilters: state.filters.tagsTabFilters,
        isExportingCsv: state.asset.isExportingCsv,
        orderParams: state.asset.assetOrderParams,
        user: state.user,
        selectedAssets: state.asset.selectedAssets,
        assetSearchIdParams: state.asset.assetSearchIdParams,
        companyTags: state.companyTags,
        fetchingTags: state.companyTags.fetchingTags,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...AssetActions,
                ...tagActions,
                ...DivisionActions,
                ...DeviceActions,
                ...FiltersActions,
            },
            dispatch,
        ),
    };
}
export const AssetsTest = Assets;
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Assets);
